import { Dialog, DialogConfig } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { LoadingDialogComponent, LoadingDialogData } from '../components/loading-dialog/loading-dialog.component';
import { RetryDialogComponent } from '../components/retry-dialog/retry-dialog.component';

export type RetryDialogData = {
  timeUntilRetry: number;
  titleText: string;
  descriptionText: string;
  confirmText: string;
  smallDescription: string;
} & Record<string, unknown>;

export type ConfirmDialogData = {
  timeUntilRetry: number;
  titleText: string;
  descriptionText: string;
  cancelText: string;
  confirmText: string;
} & Record<string, unknown>;

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private readonly dialogService: Dialog) {}

  openDialog<T = any>(component: ComponentType<T>, config: Partial<DialogConfig> = {}) {
    return this.dialogService.open(component, {
      width: config.width || '100%',
      maxWidth: config.maxWidth ?? '450px',
      disableClose: config.disableClose ?? true,
      autoFocus: config.autoFocus ?? true,
      data: config.data || {},
    });
  }

  openConfirmDialog(data: Partial<ConfirmDialogData> = {}, config: Partial<DialogConfig> = {}) {
    return this.dialogService.open<boolean>(ConfirmDialogComponent as ComponentType<ConfirmDialogComponent>, {
      width: config.width || '100%',
      maxWidth: config.maxWidth ?? '400px',
      disableClose: config.disableClose ?? true,
      autoFocus: config.autoFocus ?? true,
      data,
    });
  }

  openRetryDialog(data: Partial<RetryDialogData> = {}, config: Partial<DialogConfig> = {}) {
    return this.dialogService.open<boolean>(RetryDialogComponent as ComponentType<RetryDialogComponent>, {
      width: config.width || '100%',
      maxWidth: config.maxWidth ?? '330px',
      disableClose: config.disableClose ?? true,
      autoFocus: config.autoFocus ?? true,
      data,
    });
  }

  openLoadingDialog(data: Partial<LoadingDialogData> = {}, config: Partial<DialogConfig> = {}) {
    return this.dialogService.open<void>(LoadingDialogComponent as ComponentType<LoadingDialogComponent>, {
      width: config.width || '100%',
      maxWidth: config.maxWidth ?? '416px',
      disableClose: config.disableClose ?? true,
      autoFocus: config.autoFocus ?? false,
      data,
    });
  }
}
